export function getPortalDomain() {

	var domainsByHost = {
		//PRO
		"portal.uvaempleo.com": "uvaempleo.com",
		//PRE
		"portal-uva.dev.doubledot.es": "uvaempleo.dev.doubledot.es",
		//LOCAL
		"localhost:8080": "uvaempleo.dev.doubledot.es"
	};

	return domainsByHost[location.host] || "portal-uva.dev.doubledot.es";

}

export default {
	"dotia": {
		"name": "dotia",
		"basic": {
			"default": "#376bae",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"button": {
			"default": "#376bae",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9bb5d6",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"logo": "/static/img/brands/dotia/logo.svg",
		"logocolor": "/static/img/brands/dotia/logo-color.svg",
		"logodarkmode": "/static/img/brands/dotia/logo.svg",
		"logoSize": "small",
		"background": "/static/img/brands/dotia/background.jpg",
		"footer": {
			"es": {
				"textos": ["Dotia © 2021"]
			}
		},

		"fonts": {
			"link": "family=Lato:400,500,700",
			"principal": "'Lato', sans-serif",
			"secundaria": "'Lato', sans-serif"
		},

		"logintexts": {
			"es": {
				"antiguos": "Antiguos Alumnos",
				"estudiantes": "Estudiantes",
				"empresas": "Empresas"
			}
		},

		"listBusquedaPractica":['areaFuncional', 'areasTitulaciones', 'nivelesTitulaciones', 'tiposFormacion', 'titulaciones', 'tituloPrograma', 'tipoModalidadAsistencia'],

		//CV DEL USUARIO
		"quitarCampoDiscapacidad": true,

		//REGISTRO DE LAS EMPRESAS
		"registroEmpresas": {
			"sede": {
				"visible": true,
				"required": true
			},
			"dni": {
				"visible": true,
				"required": true
			},
		},

		"niveles": [
			{
				id: "grado",
				active: false,
				label: {
					"es": "Grado",
					"ca": "Grau"
				}
			},
			{
				id: "postgrado",
				active: false,
				label: {
					"es": "Postgrado",
					"ca": "Postgrau"
				}
			},
			{
				id: "tituloPropio", 
				active: false,
				label: {
					"es": "Título Propio",
					"ca": "Títol Propi"
				}
			}
		],

		"camposOferta": {
			"otraRemuneracion": {
				"label": {
					"es": "Otra remuneración"
				},
				"showIn": ['Empleo'],
				"required": true
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"descripcion": {
				"label": {
					"Empleo": {
						"es": "Descripción del puesto*",
					},
					"Practicas": {
						"es": "Descripción del puesto*"
					}
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			}
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración",
			},
			"tutorEmpresa": {
				"titulacion": true
			},
			"practicaRemunerada": {
				"label": {
					"es": "Práctica remunerada"
				},
				"showIn": ['Practicas']
			},
			"tipoPracticaCurriExtracurri": true,
			"solicitudParaCentroEducativo": true,
		},



		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			}
		},

		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": false
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"telefono": {
				"visible": true,
				"editable": false
			},
			"email": {
				"visible": true,
				"editable": true
			},
			"emailComunicaciones": {
				"visible": true,
				"editable": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			}
		},

		"interes": {}

	},
	"uva": {
		"name": "uva",
		"basic": {
			"default": "#1e1e1e",
			"alternative": "#8c96ff",
			"fontAlternative": "#202020",
			"darkMode": "#ffffff"
		},
		
		// "banner_home": {
		// 	"src": "/static/img/brands/uva/banner.png",
		// 	"link": "/programas-practicas-activos/xi-edicion-programa-de-formacion-de-gestores-de-i",
		// 	"internal": true
		// },
		"banner_ofertas_talento": false,
		"banner_intermediacion": true,
		"button": {
			"default": "#8c96ff",
			"font": "#ffffff",
			"darkMode": "#ffffff"
		},
		"soft_basic": {
			"default": "#8E8E8E",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/uva/logo-uva-white.png",
		"logocolor": "/static/img/brands/uva/logo-uva-black.png",
		"logoencabezado": "/static/img/brands/uva/logo-uva-black.png",
		"logodarkmode": "/static/img/brands/uva/logo-uva-white.png",
		"logoSize": "big",
		"background": "/static/img/brands/uva/background.jpg",
		"emailContacto": "funge@funge.uva.es",
		"emailInscripcion": "funge@funge.uva.es",
		"emailProblemas": "funge@funge.uva.es",
		"analitycs": "UA-119874198-1",
		"dominio_produccion": "portal.uvaempleo.com",
		"portal_publico": "https://uvaempleo.com/",
		"ownpopup_info": {
			"uso_logo": {
				"titulo": "Autorizo el uso de la imagen de la empresa",
				"texto": "Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en el portal de candidatos/as y en la web pública de empleo de FUNGE UVa. Aunque autorices ahora, cuando crees ofertas podrás configurar si quieres que se muestren o no, vinculados a esa oferta, los datos de tu empresa."
			}
		},
		"footer": {
			"es": {
				"textos": [
					"",
					""
				],
				"links": {
					"Aviso Legal": `https://${getPortalDomain()}/aviso-legal/`,
					"Política de Cookies": `https://${getPortalDomain()}/politica-de-cookies/`,
					"Política de privacidad": `https://${getPortalDomain()}/politica-de-privacidad`
				}
			}
		},
		"fonts": {
			"link": "family=Open%20Sans:400,500,700",
			"principal": "'Open Sans', sans-serif",
			"secundaria": "'Open Sans', sans-serif"
		},
		"ownstyles": "/static/img/brands/uva/style.css",
		"logintexts": {
			"es": {
				"antiguos": "Antiguos Alumnos",
				"estudiantes": "Titulados",
				"empresas": "Empresas"
			}
		},


		"urlPortalTutores": "https://tutor.uvaempleo.com/",

		//PROPUESTA DE PRÁCTICAS
		"instruccionesPropuestaPracticasEmpresas": "/static/img/brands/uva/instrucciones-propuesta-de-practicas-UVa.pdf",
		"showPropuestaPracticas": 'isEmpresa',
		"requestProgramaPracticas": true,
		"hasProgramaPracticasActivo": true,
		"requestDatosFirmanteEnPropuesta": true,

		"listBusquedaPractica":['areaFuncional', 'areasTitulaciones', 'nivelesTitulaciones', 'tiposFormacion', 'titulaciones', 'tituloPrograma', 'tipoModalidadAsistencia'],
		"proyectoTalento": false,
		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": false,
		"canDuplicarOferta": true,
		"canDeleteOferta": true,
		"otrasRemuneracionesEnPracticas": true,
		"hasAnyoMaximoPromocion": true,
		"requestDatosFirmanteEnOferta": true,
		"requestDatosTutorEnOferta": true,
		"hideCamposTutor": ["dni","titulacion"],
		"hideOpcionesCandidatos": true,
		"showMotivoRechazo": true,
		"poblacionesDomain": true,
		"tiempoDedicacionJornada": true,
		"HistoricoOfertas": true,
		"openTitulacionesSelector": true,
		"ocultarEmpresaEnOferta": true,
		"localidadesEnDominios": true,

		"niveles": [
			{
				id: "grado",
				active: false,
				label: {
					"es": "Grado",
					"ca": "Grau"
				}
			},
			{
				id: "postgrado",
				active: false,
				label: {
					"es": "Postgrado",
					"ca": "Postgrau"
				}
			},
			{
				id: "tituloPropio", 
				active: false,
				label: {
					"es": "Título Propio",
					"ca": "Títol Propi"
				}
			}
		],
		"camposOferta": {
			"tareas": {
				"showIn": ["Practicas"]
			},
			"otraRemuneracion": {
				"label": {
					"es": "Otros beneficios"
				},
				"showIn": ['Practicas', 'Empleo'],
				"required": false
			},
			"ayudaEstudio": {
				"label": {
					"es": "Beca mensual",
				},
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"otraFormacion": {
				"label": "Otra formación",
				"showIn": ['Practicas']
			},
			"anyoMaximoPromocion": {
				"label": "Año de promoción límite",
				"showIn": ['Empleo']
			},
			"descripcion": {
				"label": {
					"Empleo": {
						"es": "Descripción del puesto*",
					},
					"Practicas": {
						"es": "Descripción del puesto*"
					}
				}
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			}
		},

		"camposPracticas": {
			"tareasDesglosadas": true,
			"puestoTrabajo": {
				"label": "Puesto de trabajo",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"otraRemuneracion": {
				"label": {
					"es": "Otros beneficios"
				},
				"required": true
			},
			"ayudaEstudio": {
				"label": "Beca mensual",
				"disabledHide": true
			},
			"practicaRemunerada": {
				"label": {
					"es": "Práctica remunerada"
				},
				"showIn": ['Practicas'],
			},
			"tutorEmpresa": {
				"cargo": true,
				"departamento": true,
				"telefono": true,
				"titulacion": false
			},
			"tipoPracticaCurriExtracurri": true,
			"solicitudParaCentroEducativo": true,
		},

		//REGISTRO DE LA EMPRESA
		"requestDireccionContactoEmpresa": true,
		"requestDireccionFullContactoEmpresa": true,
		"requestDireccionFacturacion": true,
		"requestTipoEmpresa": true,
		"requestTipoContacto": true,
		"hideRequestFirmanteRegistro": true,
		"requestPerfilSectorial": true,
		"checkDatosCompletosEmpresa": true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
		},


		//CV DEL CANDIDATO
		"canEditDeLaUniversidad": true,
		"quitarCampoDiscapacidad": true,
		"estanciaenextranjero": true,
		"hasDocumentacionLigadaProcesos": true,
		"quitarCampoNotaAcademicos": true,
		"formacionComplementaria": true,
		"competenciasProfesionales": true,
		"nivelesInformaticos": true,
		"BornActive": true,
		"popupDatosObligatorios": true,
		"hasNivelesFormacion": true,

		"academicos": {
			"nivelesEstudio": {
				"editable": true
			},
			"ramaTitulacion": {
				"editable": true
			},
			"certificado": {
				"editable": true
			},
			"horas": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"nota": {
				"editable": true
			},


		},



		"personales": {
			"tipoDocumentoIdentidad": {
				"visible": true,
				"editable": false
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": true
			},
			"imagen": {
				"visible": true,
				"editable": true
			},
			"nombre": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido1": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido2": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"movil": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"genero": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"aceptaNewsletter": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"password": true,
			"iban": {
				"visible": true,
				"editable": true
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"idPaisNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"provinciaNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"lugarNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true,
					"hide": []
				},
				"2": {
					"visible": true,
					"editable": true,
					"hide": []
				}
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
			"idTipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idsubtipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idActividadProfesional": {
				"editable": true,
				"validate": 'required'
			},
			"enlace": {
				"editable": true,
				"validate": ''
			},
			"adjunto": {
				"editable": true,
				"validate": ''
			}
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			}
		},

		"interes": {},

		//REGISTRO DE LOS ALUMNOS
		"canRegistroAlumno": ['antiguos', 'estudiantes', 'alumnos'],
		"OneLoginForCandidatos": true,
		"hideSAML": true,
		"canBorrarCuenta": true,
		"checkDatosNecesariosEnLogin": true,
		"canRecoveryPass": true,
		"infoRGDP": true,

		//DOCUMENTACIÓN DE EMPRESAS
		"hasDocumentacionPrivadaCV": true,
		"canUploadDocEmpresas": true,
		"literalAnexosFirmados": "Documentos firmados para prácticas asignadas",
		"hideConveniosFirmados": true,
		"haveDocumentosPrograma": true

	},
	

}


// WEBPACK FOOTER //
// ./src/brands/brands.js